import axios from "./axios";

class InsuranceService {
  getRedirectURL = async () => {
    try {
      const response = await axios.post("/insurance/smc/redirect_url", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new InsuranceService();
